import { Box, Link, useTheme } from "@mui/material";
import CopyButton from "../copy-button";
type Props = {
  url: string;
};

export default function PostRequest({ url }: Props) {
  const theme = useTheme();

  return (
    <Box component={"div"} className="desc">
      POST{" "}
      <Link className="link" underline="always">
        {url}
      </Link>
      <CopyButton source={url} color={theme.palette?.NightText?.secondary} />
    </Box>
  );
}
